// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Wave_spinner__xyQjF","wave":"Wave_wave__rxJRZ","screenCenter":"Wave_screenCenter__13fvX","wrapper":"Wave_wrapper__1xUex","fade-blur":"Wave_fade-blur__2yoOm"};